function TD(props) {
  const { children } = props;
  return <td className="text-left px-4 py-4 my-2 ">{children}</td>;
}

export default TD;
